registerComponent("sections/home-intro", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * Só o `$(component).addClass()` saiu; o resto já era vanilla.
 *
 * ⚠️ As duas classes NÃO TÊM FOLHA. Nenhum `_*.less` do site casa `.intro-v2`
 * ou `.intro-v3` — quem estiliza as variantes da home é `.page-v2`/`.page-v3`,
 * que vem do `<body class="page-{rota}">` do layout nas rotas `site.{pt,en}.v2`
 * e `.v3` (`/home-v2`, `/home-v3`), e não deste arquivo, que olha a QUERY
 * STRING. Ficam como estavam: o programa proíbe remover sem as quatro
 * checagens do protocolo, e o destino das três rotas de variante é decisão da
 * Fase 9.
 */

const urlParams = new URLSearchParams(window.location.search);

if (urlParams.has('home-v2')) {
    component.classList.add('intro-v2');
}

if (urlParams.has('home-v3')) {
    component.classList.add('intro-v3');
}

});
